import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MarketAvitoApi from '../../../API/market/avito-api';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { SendButton, Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { TYPE_BUTTONS } from '../../../constans';
import styles from './styles.module.scss';
import AvitoTable from './Table';

const AvitoPage = () => {
  const dispatch = useDispatch();

  const [provider, changeProvider] = useState();
  const [providers, setProviders] = useState([]);
  const [providerData, setProviderData] = useState({ status_stock: '', date_stock_update: null });

  const [market, setMarket] = useState('kuper1');
  const allProviders = useSelector((store) => store.providers);
  const user = useSelector((store) => store.user);

  useEffect(() => {
    const p = allProviders.filter((item) => !item['hide']);
    if (p.length > 0) {
      setProviders(p);
      changeProvider(p[0] || {});
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  useEffect(() => {
    if (provider) {
      console.log(provider);
      setProviderData(provider.markets_update?.['kuper']);
    }
  }, [provider]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <>
      <Content>
        <WhiteBlock title="Управление" title_bold={`Авито`} style={{ margin: '10px 0' }} minimize={true}>
          <Row style={{ alignItems: 'stretch' }}>
            <Column className={styles.stosks_column}>
              <Row style={{ alignItems: 'flex-end', marginRight: '15px' }}>
                <Column style={{ marginRight: '15px' }}>
                  <Row style={{ alignItems: 'flex-end' }}>
                    <SendButton
                      sendData={{ data: { shop: 'avito1' } }}
                      sendApi={MarketAvitoApi.updateByExcel}
                    >
                      Подгрузить данные
                    </SendButton>
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      onClick={() => MarketAvitoApi.updateStocks({ data: { shop: 'avito1' } })}
                      style={{ marginLeft: '15px', width: '100%' }}
                    >
                      Обновить остатки
                    </Button>
                  </Row>
                </Column>
              </Row>

              <Row style={{ marginTop: '10px' }}>
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  onClick={() => MarketAvitoApi.excelFeed({ data: { shop: 'avito1' } })}
                  style={{ marginRight: '15px' }}
                >
                  Скачать фид
                </Button>
              </Row>
            </Column>
          </Row>
        </WhiteBlock >

        <AvitoTable />
      </Content >
    </>
  );
};

export default AvitoPage;
